import React from 'react';

function CoordinatorForm() {
  return (
    <div>
      <h2>CoordinatorForm</h2>
    </div>
  );
}

export default CoordinatorForm;
